module.exports = __webpack_public_path__ + "img/section3.67f9890a.jpg";